import { compose, curry, defaultTo, filter, map, prop, propOr } from 'ramda';

import { isNotVoid } from '../../../helpers/compact';

const mapFilter = curry((cb, array) =>
  compose(filter(isNotVoid), map(cb), defaultTo([]))(array)
);

const slicesFromProp = (parsers, propName, data) =>
  compose(
    mapFilter(({ slice_type, ...rest }) => {
      const parser = propOr(() => null, slice_type, parsers);
      return parser(rest);
    }),
    prop(propName)
  )(data);

export default slicesFromProp;
